var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',[_c('h1',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.$t('lbl_welcome_to_hodo_e_commerce')))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }